import React, { MouseEvent } from 'react';
import * as GStyled from '../../../styles/components';
import * as Styled from './styled';
import { Icon } from '../../../components';

interface FieldActionMenuProps {
  isAddedFavorite?: boolean;
  isLoading?: boolean;
  onAddToRuleBuilderClick?: (e: MouseEvent) => void;
  onAddToFavoriteClick?: (e: MouseEvent) => void;
  onRemoveFromFavoriteClick?: (e: MouseEvent) => void;
}

function FieldActionMenu({
  isAddedFavorite,
  isLoading,
  onAddToRuleBuilderClick: onAddToReportBuilderClick,
  onAddToFavoriteClick,
  onRemoveFromFavoriteClick,
}: FieldActionMenuProps): JSX.Element {
  return (
    <Styled.FieldActionMenu>
      <Styled.FieldActionMenuItem onClick={onAddToReportBuilderClick}>
        <Styled.FieldActionMenuItemWrapper>
          <Icon name="plus" />
          <GStyled.Text size="sm" fontWeight="medium">
            Add to report builder
          </GStyled.Text>
        </Styled.FieldActionMenuItemWrapper>
      </Styled.FieldActionMenuItem>
      {isAddedFavorite ? (
        <Styled.FieldActionMenuItem
          onClick={onRemoveFromFavoriteClick}
          disabled={isLoading}
        >
          <Styled.FieldActionMenuItemWrapper>
            {isLoading ? (
              <Icon name="inprogress" isSpin width={12} height={12} />
            ) : (
              <Icon name="star" />
            )}
            <GStyled.Text size="sm" fontWeight="medium">
              Remove from favorites
            </GStyled.Text>
          </Styled.FieldActionMenuItemWrapper>
        </Styled.FieldActionMenuItem>
      ) : (
        <Styled.FieldActionMenuItem
          onClick={onAddToFavoriteClick}
          disabled={isLoading}
        >
          <Styled.FieldActionMenuItemWrapper>
            {isLoading ? (
              <Icon name="inprogress" isSpin width={12} height={12} />
            ) : (
              <Icon name="filledStar" />
            )}
            <GStyled.Text size="sm" fontWeight="medium">
              Add to favorites
            </GStyled.Text>
          </Styled.FieldActionMenuItemWrapper>
        </Styled.FieldActionMenuItem>
      )}
    </Styled.FieldActionMenu>
  );
}

export default FieldActionMenu;
